import { Fragment, h } from "preact";
import { useSelector } from 'react-redux'
import AlertExemption from '../../components/Alerts/AlertExemption'
import { t } from '../../../_i18n'

const STATE_3 = '3.3'

export default function Convention () {
  const screenStatus = useSelector(state => state.fct.screenState)
  const screenState = screenStatus.screen

  return (
    <div>
      { screenState === STATE_3 && <AlertExemption exemption={screenStatus.screen_data.exemption_percent} className='m-bottom' /> }
      <div className='font-bold'>{t('Estamos en conversación con la empresa para poder acordar las condiciones y fecha de inicio de tus prácticas.')}</div>
      <div className='m-top'>{t('Cuando este listo, contactaremos contigo para notificarte el acuerdo final.')} </div>
    </div>
  )
}
